// extracted by mini-css-extract-plugin
export var defaultWrapper = "_l7-3";
export var downloadButton = "_l7-4";
export var fileContainer = "_l7-9 _l7-7";
export var fileContainerBase = "_l7-7";
export var fileContainerFixedHeight = "_l7-8 _l7-7";
export var fileInfo = "_l7-5";
export var fileInfoWidthRestricted = "_l7-6";
export var fileType = "_l7-1";
export var fileTypeName = "_l7-2";
export var image = "_l7-0";
export var link = "_l7-b";
export var overflowEllipsis = "_l7-a";